import script from "./UpgradeListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpgradeListView.vue?vue&type=script&lang=ts&setup=true"

import "./UpgradeListView.vue?vue&type=style&index=0&id=e81027d4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e81027d4"]])

export default __exports__